const siteUrl = import.meta.env.VITE_PUBLIC_SITE_URL || "https://example.com";

type SeoInput = {
  title: string;
  description?: string;
  path?: string;
  noindex?: boolean;
};

export function setSeo({ title, description, path = "/", noindex = false }: SeoInput) {
  document.title = title;
  setMeta("description", description || "Browse My Local Forum discussions and local community updates.");
  setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
  setCanonical(new URL(path, siteUrl).toString());
}

function setMeta(name: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.name = name;
    document.head.appendChild(element);
  }
  element.content = content;
}

function setCanonical(href: string) {
  let element = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.rel = "canonical";
    document.head.appendChild(element);
  }
  element.href = href;
}

